import { Component } from '@angular/core';
import { AuthenticationService } from '../shared/services/authentication.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent {
  username: string = '';
  constructor(private authService: AuthenticationService, private router: Router) { }

  ngOnInit(): void {
    if (sessionStorage.getItem('username')) {
      this.username = JSON.parse(sessionStorage.getItem('username') || '');
    }
  }

  logout(): void {
    this.authService.logout();
    this.router.navigate(['/auth/login']);
  }
}
